import type { VideoTemplate } from '@/types/template';

interface TemplatePreviewProps {
  template: VideoTemplate | null;
}

interface ParameterSchema {
  default?: unknown;
  type?: string;
  min?: number;
  max?: number;
}

export function TemplatePreview({ template }: TemplatePreviewProps) {
  if (!template) {
    return (
      <div className="border border-gray-200 rounded-md p-8 text-center">
        <p className="text-sm font-light text-gray-500">
          Selecciona una plantilla para ver la vista previa
        </p>
      </div>
    );
  }

  const parameters = template.parameter_schema?.parameters as Record<string, ParameterSchema> | undefined;

  return (
    <div className="border border-gray-200 rounded-md overflow-hidden">
      <div className="bg-gray-50 p-4 border-b border-gray-200">
        <h3 className="font-medium text-gray-900">{template.name}</h3>
        <p className="text-sm font-light text-gray-600 mt-1">{template.description}</p>
      </div>

      {template.preview_url && (
        <div className="aspect-[9/16] bg-black max-h-96">
          <video
            src={template.preview_url}
            className="w-full h-full object-contain"
            controls
            muted
            playsInline
          />
        </div>
      )}

      {parameters && Object.keys(parameters).length > 0 && (
        <div className="p-4 bg-gray-50 border-t border-gray-200">
          <h4 className="text-sm font-medium text-gray-900 mb-2">Parámetros</h4>
          <div className="space-y-1 text-xs font-light text-gray-600">
            {Object.entries(parameters).map(([key, param]) => (
              <div key={key} className="flex justify-between">
                <span className="capitalize">{key.replace(/_/g, ' ')}:</span>
                <span>
                  {param.default?.toString() || 'N/A'}
                  {param.type === 'number' && ` (${param.min} - ${param.max})`}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
